import mBankBoldWoff from 'assets/fonts/mBank/mBank-Bold.woff';
import mBankBoldWoff2 from 'assets/fonts/mBank/mBank-Bold.woff2';
import mBankLightWoff from 'assets/fonts/mBank/mBank-Light.woff';
import mBankLightWoff2 from 'assets/fonts/mBank/mBank-Light.woff2';
import mBankRegularWoff from 'assets/fonts/mBank/mBank-Regular.woff';
import mBankRegularWoff2 from 'assets/fonts/mBank/mBank-Regular.woff2';
import mBankMediumWoff from 'assets/fonts/mBank/mBank-SemiBold.woff';
import mBankMediumWoff2 from 'assets/fonts/mBank/mBank-SemiBold.woff2';
import montserratBoldWoff from 'assets/fonts/Montserrat/Montserrat-Bold.woff';
import montserratBoldWoff2 from 'assets/fonts/Montserrat/Montserrat-Bold.woff2';
import montserratLightWoff from 'assets/fonts/Montserrat/Montserrat-Light.woff';
import montserratLightWoff2 from 'assets/fonts/Montserrat/Montserrat-Light.woff2';
import montserratMediumWoff from 'assets/fonts/Montserrat/Montserrat-Medium.woff';
import montserratMediumWoff2 from 'assets/fonts/Montserrat/Montserrat-Medium.woff2';
import montserratRegularWoff from 'assets/fonts/Montserrat/Montserrat-Regular.woff';
import montserratRegularWoff2 from 'assets/fonts/Montserrat/Montserrat-Regular.woff2';
import { styles } from 'consts';
import { createGlobalStyle } from 'styled-components';

const { background, whiteDarker, fontMBank } = styles;

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
  }

  html, body {
    font-size: 16px;
    height: 100%;
    background-color: ${whiteDarker};
    font-family: sans-serif;
    box-sizing: content-box;
    font-family: ${fontMBank} sans-serif;
    scroll-behavior: smooth;

    @media (min-width: 768px) {
      background-color: ${background};
    }
  }

  input {
    border: none;
    background: none;
  }

  #root {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  #modal-root>div {
    position: absolute;
    background: rgba(155,155,155,.4);
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 999;
  }
  
  button {
    border: none;
  }
  
  /* mBank */
  @font-face {
    font-family: 'mBank';
    font-weight: 300;
    src: url(${mBankLightWoff2}) format('woff2'),
         url(${mBankLightWoff}) format('woff');
  }

  @font-face {
    font-family: 'mBank';
    font-weight: normal;
    src: url(${mBankRegularWoff2}) format('woff2'),
         url(${mBankRegularWoff}) format('woff');
  }

  @font-face {
    font-family: 'mBank';
    font-weight: 500;
    src: url(${mBankMediumWoff2}) format('woff2'),
         url(${mBankMediumWoff}) format('woff');
  }

  @font-face {
    font-family: 'mBank';
    font-weight: bold;
    src: url(${mBankBoldWoff2}) format('woff2'),
         url(${mBankBoldWoff}) format('woff');
  }

  /* Montserrat */
  @font-face {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 300;
    src: local('Montserrat Light'), 
         local('Montserrat-Light'), 
         url(${montserratLightWoff}) format('woff2'),
         url(${montserratLightWoff2}) format('woff');
  }

  @font-face {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 400;
    src: local('Montserrat Regular'), 
         local('Montserrat-Regular'), 
         url(${montserratRegularWoff2}) format('woff2'),
         url(${montserratRegularWoff}) format('woff');
  }

  @font-face {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 600;
    src: local('Montserrat SemiBold'), 
         local('Montserrat-SemiBold'), 
         url(${montserratMediumWoff2}) format('woff2'),
         url(${montserratMediumWoff}) format('woff');
  }

  @font-face {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 700;
    src: local('Montserrat Bold'), 
         local('Montserrat-Bold'), 
         url(${montserratBoldWoff2}) format('woff2'),
         url(${montserratBoldWoff}) format('woff');
  }
`;
